import TspApiService from "../../api/tspApiService";
import { tspErrorMessage } from "../../hooks/useTspApiResource";
import { buildJourneyQuery } from "./useTspJourneysListData";

// The list's applied filters as the export's query: the same filters and order
// as the table, without paging (the server exports every matching journey).
export function buildJourneyExportQuery(filters) {
  const { page, limit, ...query } = buildJourneyQuery(filters, 1);
  return query;
}

// Blob.text(), with a FileReader fallback for browsers (and jsdom) without it.
const blobText = (blob) =>
  typeof blob.text === "function"
    ? blob.text()
    : new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
      });

// A failed download arrives as a Blob too: read the server's message out of it.
export async function exportErrorMessage(error) {
  const data = error?.response?.data;
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      const parsed = JSON.parse(await blobText(data));
      if (parsed?.message) return parsed.message;
    } catch {
      // not JSON: fall through to the generic message
    }
  }
  return tspErrorMessage(error, "Could not export the journeys. Please try again.");
}

// GET /tsp/journeys/export for the applied filters, saved as journeys-<date>.xlsx.
export default async function downloadJourneysExport(filters) {
  const blob = await TspApiService.exportJourneys(buildJourneyExportQuery(filters));
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `journeys-${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
